import {
  ContentState,
  convertFromHTML,
  convertToRaw,
  EditorState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

export const createEditorContent = html =>
  EditorState.createWithContent(
    ContentState.createFromBlockArray(htmlToDraft(html || "").contentBlocks)
  );
export const createEditorState = html => {
  const blocks = convertFromHTML(html);
  return EditorState.createWithContent(
    ContentState.createFromBlockArray(blocks.contentBlocks, blocks.entityMap)
  );
};
export const editorStateToHtml = editorState => {
  if (!editorState) return "";
  const rawContent = convertToRaw(editorState.getCurrentContent());
  return draftToHtml(rawContent);
};

export default {
  createEditorState,
  editorStateToHtml,
  createEditorContent,
};
